import { createError } from './create-error';
export const MessageBrokeringError = createError('MessageBrokeringError', 'Failed to broker message', {
  SUBSCRIPTION_STORE_UNAVAILABLE: 'Subscription store unavailable.',
  FAILED_TO_GET_SUBSCRIBERS: 'Failed to obtain the list of subscribers.',
  FAILED_TO_BROKER_MESSAGE: 'Failed to broker message.'
});